import Layout from "@/layout";

const insureManageRouter = {
  path: "	/insureManage",
  component: Layout,
  redirect: "/insureManage",
  name: "insureManage",
  meta: {
    title: "保险管理"
  },
  children: [
    {
      path: "/insureManage/carsInsure",
      component: () => import("@/views/insureManage/carsInsure/index"),
      name: "carsInsure",
      meta: { title: "车辆保险", icon: "" },
      alwaysShow: true
    },
    {
      path: "/insureManage/peopleInsure",
      component: () => import("@/views/insureManage/peopleInsure/index"),
      name: "peopleInsure",
      meta: { title: "人员保险", icon: "" },
      alwaysShow: true
    },
    {
      path: "/insureManage/policyIns",
      component: () => import("@/views/insureManage/policyIns/index"),
      name: "policyIns",
      meta: { title: "购买保险", icon: "" },
      alwaysShow: true
    },
    {
      path: "/insureManage/hisPolicy",
      component: () => import("@/views/insureManage/hisPolicy/index"),
      name: "hisPolicy",
      meta: { title: "历史保单", icon: "" },
      alwaysShow: true
    },
  ]
};

export default insureManageRouter;
